import styled from "styled-components";
import { BsFillMoonFill, BsFillSunFill } from "react-icons/bs";
import { useDarkMode } from "../context/DarkModeContext";

const StyledThemeToggle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  svg {
    font-size: 1.8rem;
  }
`;

const ToggleWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  cursor: pointer;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .toggle-slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--color-grey-300);
    transition: 0.4s;
    border-radius: 22px;
  }

  .toggle-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .toggle-slider {
    background-color: var(--color-indigo-700);
  }

  input:checked + .toggle-slider:before {
    transform: translateX(18px);
  }

  .toggle-slider.round {
    border-radius: 22px;
  }
`;

function ThemeToggle() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  return (
    <StyledThemeToggle>
      <BsFillSunFill />
      <ToggleWrapper>
        <input type="checkbox" checked={isDarkMode} onChange={toggleDarkMode} />
        <span className="toggle-slider round"></span>
      </ToggleWrapper>
      <BsFillMoonFill />
    </StyledThemeToggle>
  );
}

export default ThemeToggle;
